/**
 * Strip internal-only text from estimate notes so we never show
 * "AI-generated roof estimate. Confidence: XX%" or "Note: Based on X squares... AI confidence" to clients or in UI.
 */
export function getDisplayNotes(notes: string | null | undefined): string {
  if (!notes || typeof notes !== 'string') return '';
  return notes
    .replace(/\s*AI-generated roof estimate\.\s*Confidence:\s*\d+%\s*/gi, '')
    .replace(/\s*Note:\s*Based on[\s\S]*?AI confidence:\s*\d+%\.?\s*/gi, '')
    .replace(/\s*Based on \d+\.?\d*\s*squares,?\s*\w+\s*complexity\.?\s*AI confidence:\s*\d+%\.?\s*/gi, '')
    .trim();
}

/** Strip internal-only lines from description text (e.g. roof line item). */
export function sanitizeEstimateDescription(description: string | null | undefined): string {
  if (!description || typeof description !== 'string') return '';
  const lines = description.split(/\r?\n/).filter((line) => {
    const t = line.trim();
    if (!t) return true;
    if (/^\-?\s*Address\s*\.{0,3}\s*$/i.test(t)) return false;
    if (/^\-?\s*Address\s*\.{2,}\s*$/i.test(t)) return false;
    if (/Note:\s*Based on.*AI confidence/i.test(t)) return false;
    if (/Based on \d+\.?\d*\s*squares.*complexity.*AI confidence/i.test(t)) return false;
    return true;
  });
  return lines.join('\n').trim();
}
